import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import * as mobxReact from 'mobx-react';
import classNames from 'classnames';
import { ButtonType, SearchInput } from '../../../../../global/search-input/search-input';
import ReportSelectedFields from '../../../shared/report-selected-fields/report-selected-fields';
import ReportGroupedFields from '../../../shared/report-grouped-fields/report-grouped-fields';
import { ReportConfigurationViewModel } from '../../report-configuration/report-configuration.viewmodel';
import { ReportType } from '../../../../../../api/reports.dao';
import { LayoutOption } from '../layout-options/layout-options';
import { loadingText } from '../../../../../../constants/common-labels.constants';


interface IProps {
    intl: IntlShape;
    configurationVm: ReportConfigurationViewModel;
}

const EventReportColumnsTab = injectIntl(mobxReact.observer((props: IProps) => {
    const { intl, configurationVm } = props;
    const { withLayout, layoutType, applyLayout, isLoadingLayoutFields, type } = configurationVm;

    return (
        <div className='generate-event-report__wrapper'>
            <div className={classNames('generate-event-report__sidebar', {
                'generate-event-report__sidebar--with-layout': withLayout
            })}>
                <div className='generate-event-report__sidebar-header'>
                    <div className='generate-event-report__search-input-container'>
                        <SearchInput
                            placeholder={intl.formatMessage({
                                id: 'oe.reports.searchForAField',
                                description: 'Search input for report fields',
                                defaultMessage: 'Search for a Field'
                            })}
                            onChange={(e, value) => configurationVm.setSearchValue(value)}
                            resetSearch={() => configurationVm.setSearchValue('')}
                            className="w-100 generate-event-report__search-input"
                            buttonType={ButtonType.Black}
                            value={configurationVm.searchValue}
                            withResetSearchButton
                        />
                    </div>
                </div>
                { withLayout && (
                    <LayoutOption
                        layoutType={layoutType}
                        applyLayout={applyLayout}
                    />
                )}
                <ReportSelectedFields vm={configurationVm} />
            </div>
            <div className='generate-event-report__content'>
                { type === ReportType.ATTENDEE_INTERACTIONS_REPORT && isLoadingLayoutFields
                    ? loadingText()
                    : <ReportGroupedFields vm={configurationVm} />
                }
            </div>
        </div>
    );
}));

export default EventReportColumnsTab;
